
/**
 * 수강신청 유형
 */
export type EnrollmentCreateRequestEnrollmentType = typeof EnrollmentCreateRequestEnrollmentType[keyof typeof EnrollmentCreateRequestEnrollmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollmentCreateRequestEnrollmentType = {
  REGULAR: 'REGULAR',
  AUDIT: 'AUDIT',
  PREMIUM: 'PREMIUM',
  TRIAL: 'TRIAL',
} as const;
